import { initializeApp } from 'firebase/app';
import { getFirestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDlUWrMJ9J_19JXYVCTH7fAVXlzq9VuV74",
  authDomain: "smultron.plan8.co",
  projectId: "smultron-8e1b7",
  storageBucket: "smultron-8e1b7.firebasestorage.app",
  messagingSenderId: "410005096789",
  appId: "1:410005096789:web:358862c1bf1b6f15a487dc"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  cache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  }),
  experimentalForceLongPolling: true
});
  